export { default as ProductsElasticSearchContentHeader } from './ProductsElasticSearchContentHeader';
